import { ApiConfig, HttpMethod, DynamicUrl, MICRO_SERVER_URL_SLA } from '../constant';

const URL_AUTOMATIONS = `${MICRO_SERVER_URL_SLA}/core/automations`;
const URL_AUTOMATION_GROUPS = `${MICRO_SERVER_URL_SLA}/core/automation-groups`;
const URL_POLICIES = `${MICRO_SERVER_URL_SLA}/sla/policies`;
const URL_SLA_CASES = `${MICRO_SERVER_URL_SLA}/sla/cases`;
const URL_CONDITIONS = `${MICRO_SERVER_URL_SLA}/core/conditions`;
const URL_ACTIONS = `${MICRO_SERVER_URL_SLA}/core/actions`;

/* automations */
export const automationsWithPage: ApiConfig = {
  url: `${URL_AUTOMATIONS}`,
};

export const automationsDetail: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `${URL_AUTOMATIONS}/${String(id)}`,
};

export const automationsCreate: ApiConfig = {
  url: `${URL_AUTOMATIONS}`,
  method: HttpMethod.POST,
};

export const automationsUpdate: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `${URL_AUTOMATIONS}/${String(id)}`,
  method: HttpMethod.PUT,
};

export const automationsPartialUpdate: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `${URL_AUTOMATIONS}/${String(id)}`,
  method: HttpMethod.PATCH,
};

export const automationsSort: ApiConfig = {
  url: `${URL_AUTOMATIONS}`,
  method: HttpMethod.PATCH,
};

export const automationsDelete: ApiConfig<DynamicUrl> = {
  url: (id: number | string) => `${URL_AUTOMATIONS}/${String(id)}`,
  method: HttpMethod.DELETE,
};

export const automationsCasesWithPage: ApiConfig = {
  url: `${URL_AUTOMATIONS}/cases`,
  method: HttpMethod.POST,
};

/* automations group */
export const automationsGroup: ApiConfig = {
  url: `${URL_AUTOMATION_GROUPS}/automations`,
};

export const automationsGroupCategory: ApiConfig = {
  url: `${URL_AUTOMATION_GROUPS}`,
};

export const automationsGroupDelete: ApiConfig<DynamicUrl> = {
  url: (id: number | string) => `${URL_AUTOMATION_GROUPS}/${String(id)}`,
  method: HttpMethod.DELETE,
};

export const automationsGroupCreate: ApiConfig = {
  url: `${URL_AUTOMATION_GROUPS}`,
  method: HttpMethod.POST,
};

export const automationsGroupUpdate: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `${URL_AUTOMATION_GROUPS}/${String(id)}`,
  method: HttpMethod.PUT,
};

export const automationsGroupDeleteCheck: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `${URL_AUTOMATION_GROUPS}/delete-check/${String(id)}`,
};

export const automationsGroupSort: ApiConfig = {
  url: `${URL_AUTOMATION_GROUPS}`,
  method: HttpMethod.PATCH,
};

/* policies */
export const policiesWithPage: ApiConfig = {
  url: `${URL_POLICIES}`,
};

export const policiesCreate: ApiConfig = {
  url: `${URL_POLICIES}`,
  method: HttpMethod.POST,
};

export const policiesDetail: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `${URL_POLICIES}/${String(id)}`,
};

export const policiesUpdate: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `${URL_POLICIES}/${String(id)}`,
  method: HttpMethod.PUT,
};

export const policiesDelete: ApiConfig<DynamicUrl> = {
  url: (id: number | string) => `${URL_POLICIES}/${String(id)}`,
  method: HttpMethod.DELETE,
};

export const policiesSort: ApiConfig = {
  url: `${URL_POLICIES}`,
  method: HttpMethod.PATCH,
};

/* sla cases */
export const slaCases: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `${URL_SLA_CASES}/${String(id)}/targets`,
};

/* conditions */
export const conditions: ApiConfig = {
  url: `${URL_CONDITIONS}`,
};

/* actions */
export const actions: ApiConfig = {
  url: `${URL_ACTIONS}`,
};

export const actionsNotificationPlaceholder: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `${URL_ACTIONS}/notification/placeholder/${String(id)}`,
};
